export default __webpack_public_path__ + "static/media/CloudCheck.60b819ed.svg";